import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Tooltip, Icon, Button } from "antd";
import "./buttons.css";
import Strings from "../../../systemVariables/languageStrings";

export function SaveButton(props) {
  return (
    <Fragment>
      <Link
        to={{
          pathname: props.link,
          props: props.props,
        }}
      >
        <Tooltip title={props.tooltip}>
          <Button id="saveButton" onClick={props.onClick} disabled={props.isDisabled} loading={props.loading} className="button">
            {props.loading ? "" : <Icon type="save" theme="twoTone" twoToneColor="#52c41a" hidden={props.hideIcon} />}
            <span>{Strings.generalTerms.save}</span>
          </Button>
        </Tooltip>
      </Link>
    </Fragment>
  );
}
